module.exports = __webpack_public_path__ + "media/packs/images/flags/BH-a930be38df6182ff81b851e51dfa7d11.svg";